
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonReactivate from '~/components/common/buttons/ButtonReactivate.vue'
import ApplyReactivate from '~/components/common/maintenance/ApplyReactivate.vue'
type Referer = 'credibility' | 'applicant_count' | 'application_status' | 'automatically_reapply' | 'payment';
@Component({
  components: {
    ButtonReactivate,
    ApplyReactivate
  }
})
export default class ReactivateProTooltip extends Vue {
  @Prop({ type: String }) referrer!: Referer
  @Prop({ type: Boolean, default: false }) shown: boolean
}
